import React from "react";
import { CaretDown } from "../svg/Icons";
import "./CarouselIndicator.scss";

const CarouselIndicator = ({ onChangeIndex, idx, length, className, ...props }) => {
	return (
		<div className="carousel-indicator flex-all-center mt-lg">
			<button className="nav-button prev" onClick={() => onChangeIndex(idx === 0 ? length - 1 : idx - 1)}>
				<CaretDown width="2.8rem" height="2.8rem" stroke="#193560" />
			</button>
			<div className="indicators">
				{[...Array(length)]?.map((_, ct) => (
					<div
						key={"indicator-" + ct}
						className={`indicator ${ct === idx ? "active" : ""}`}
						onClick={() => onChangeIndex(ct)}
					/>
				))}
			</div>
			<button className="nav-button next" onClick={() => onChangeIndex(idx === length - 1 ? 0 : idx + 1)}>
				<CaretDown width="2.8rem" height="2.8rem" stroke="#193560" />
			</button>
		</div>
	);
};

export default CarouselIndicator;
